import React, { useEffect, useState } from "react";
import { TextField, styled, Box, Typography } from "@mui/material";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import VerifyOtp from "./VerifyOtp";
import InputField from "./InputField";
import { formatTime } from "../../utils/formatTime";
import { post } from "../../utils/api";

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px",
  },
}));

const EmailField1 = ({
  title,
  value,
  fieldName,
  placeholder,
  element,
  setFormData,
  formData,
  showIcon,
  setErrors,
  errors,
  verify,
  setVerify,
  verifybtn,
  setverifybtn,
  TaskAltIcons,
  setTaskAltIcons,
}) => {
  const [otp, setOTP] = useState({
    email: null,
  });

  const [timerEmail, setTimerEmail] = useState(120);
  const [timerActive, setTimerActive] = useState({
    email: false,
  });

  useEffect(() => {
    if (timerActive.email && timerEmail > 0) {
      const timer = setInterval(() => {
        setTimerEmail((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(timer);
            setTimerActive((prev) => ({ ...prev, email: false }));
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [timerActive.email, timerEmail]);

  const handleEmailChange = (e) => {
    const { name, value } = e.target;
    // console.log(name, value);

    setTaskAltIcons((prevState) => ({ ...prevState, email: false }));
    setVerify((prevState) => ({ ...prevState, email: false, emailMsg: "" }));
    setverifybtn((prevState) => ({ ...prevState, email: false }));
    setTimerEmail(120);

    setOTP((prevOtp) => ({
      ...prevOtp,
      email: "", // Update the OTP value
    }));
    const trimmedValue = value.trim();
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailPattern.test(trimmedValue)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: "Invalid email format", // Set the error message
      }));
      // console.log("invalid email format", errors);
      setverifybtn((prevState) => ({ ...prevState, email: false }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: "",
      }));
      setverifybtn({ ...verifybtn, email: true });
    }

    if (value === element?.email) {
      setTaskAltIcons((prevState) => ({ ...prevState, email: true }));
      return;
    }
    setFormData({
      ...formData,
      [name]: trimmedValue,
    });

    setErrors((prevErrors) => ({
      ...prevErrors,
      email: "", // Clear only the email error
    }));
  };

  const handleVerifyEmail = async (time) => {
    if (time > 0) {
      setverifybtn((prevState) => ({ ...prevState, email: false }));
      setTimerActive((prev) => ({ ...prev, email: true }));
      await post(`/auth/sendOtpToEmail`, {
        email: formData.email,
        module: "Purchase",
      })
        .then((res) => {
            setVerify((prevState) => ({
              ...prevState,
              email: true,
              emailMsg: "",
            }));
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data.statusCode === false) {
            setErrors((prevErrors) => ({
              ...prevErrors,
              email: "Email already registered.", // Clear only the email error
            }));
            return;
          }
        });
    } else {
      setVerify((prevState) => ({ ...prevState, email: false }));
      setverifybtn((prevState) => ({ ...prevState, email: false }));
    }
  };
  const handleResend = () => {
    setTimerEmail(120); // Reset time to 120 seconds
    setTimerActive((prev) => ({ ...prev, email: true })); // Start the timer
    handleVerifyEmail(120); // Call the email verification function
  };

  const handleOTPVerify = (e) => {
    const { value } = e.target;

    const isNumeric = /^\d+$/.test(value) || value === ""; // Allow empty string to support deletion

    if (isNumeric && value.length <= 4) {
      setVerify((prevState) => ({ ...prevState, emailMsg: "" }));
      setOTP((prevOtp) => ({
        ...prevOtp,
        email: value, // Update the OTP value
      }));
      if (value.length === 4) {
        post(`/auth/verifyOtpForEmail`, {
          email: formData.email,
          otp: value,
        })
          .then((res) => {
            // console.log("OTP verified successfully:", res, res.status);
            setVerify((prevState) => ({
              ...prevState,
              email: false,
              emailMsg: "",
            }));
            setverifybtn((prevState) => ({ ...prevState, email: false }));
            setTaskAltIcons((prevState) => ({ ...prevState, email: true }));
            setErrors((prevState) => ({ ...prevState, email: "" }));
          
          })
          .catch((err) => {
            console.error("Error verifying OTP:", err);
            setVerify({ ...verify, emailMsg: "Invalid OTP" });
            setTaskAltIcons({ ...TaskAltIcons, email: false });
          });
      }
    }
  };

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
        {title}
      </Typography>
      <CustomTextField
        variant="outlined"
        fullWidth
        value={value}
        placeholder={placeholder}
        name={fieldName}
        type="email"
        onChange={handleEmailChange} // Use the new input change handler
        InputProps={{
          endAdornment: showIcon && <TaskAltIcon sx={{ color: "green" }} />,
        }}
      />
      {errors && (
        <Typography variant="body2" color="#D34040">
          {errors}
        </Typography>
      )}
      {verifybtn.email && formData?.email !== "" && (
        <VerifyOtp
          handleChange={() => handleVerifyEmail(120)}
          text={"Verify"}
        />
      )}

      {verify.email && formData?.email !== "" && (
        <Box>
          <InputField
            value={otp.email}
            handleChange={handleOTPVerify}
            fieldName="otpEmail"
            placeholder="Enter OTP"
            title={"Enter OTP For Email"}
          />
          <Typography variant="body2" color="#D34040">
            {verify.emailMsg}
          </Typography>
          {timerActive.email ? (
            <Box sx={{ textAlign: "right" }}>{formatTime(timerEmail)}</Box>
          ) : (
            <VerifyOtp handleChange={() => handleResend()} text="Resend" />
          )}
        </Box>
      )}
    </Box>
  );
};

export default EmailField1;
